import "./instrument";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./assets/styles/styles.scss";
import { AppContextProvider } from "./lib/contexts/app-context";
import { BookingContextProvider } from "lib/contexts/booking-context";
import { CheckoutProvider } from "lib/contexts/practitioner-subscriptions-context";
import ErrorBox from "lib/components/common/error-box";
import SimpleButton from "lib/components/common/simple-button";
import { openUrlInSameTab } from "lib/utils/util";
import { DEFAULT_APP_VAR } from "lib/constants";

const container = document.getElementById("root");
const root = createRoot(container, {
  identifierPrefix: "heal-fe",

  onRecoverableError: Sentry.reactErrorHandler(),
});

const handleLogout = () => {
  openUrlInSameTab(process.env.REACT_APP_BASE_URL);
};

root.render(
  <AppContextProvider>
    <BookingContextProvider>
      <CheckoutProvider>
        <Sentry.ErrorBoundary
          fallback={
            <ErrorBox message="An error has occurred. Please restart your session by logging in again">
              <SimpleButton onClick={handleLogout}>Logout</SimpleButton>
            </ErrorBox>
          }
        >
          <App />
        </Sentry.ErrorBoundary>
      </CheckoutProvider>
    </BookingContextProvider>
  </AppContextProvider>
);
